import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultFavoriteSkillsPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};
const defaultFavoriteSkillsFilter = {
	$skip: defaultFavoriteSkillsPagination.$skip,
	$limit: defaultFavoriteSkillsPagination.$limit,
};
export default {
	state: {
		favoriteSkills: [],
		favoriteSkillsPagination: defaultFavoriteSkillsPagination,
		FavoriteSkillsFilter: defaultFavoriteSkillsFilter,
	},
	getters: {
		setfavoriteSkillsPage: (state) => {
			const { $limit, $skip } = state.favoriteSkillsPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_FAVORITE_SKILLS: (state, data) => { state.favoriteSkills = data; },
		SET_FAVORITE_SKILLS_PAGINATION: (state, data) => { state.favoriteSkillsPagination = {...state.favoriteSkillsPagination, ...data};},
		SET_FAVORITE_SKILLS_FILTER: (state, filter) => { state.FavoriteSkillsFilter = { ...state.FavoriteSkillsFilter, ...filter }; },
		SET_FAVORITE_SKILLS_PERMISSION: (state, favoriteSkillsPermission) => { state.favoriteSkillsPermission = favoriteSkillsPermission; },
	},
	actions: {
		setFavoriteSkillsFilter: ({ commit }, filter) => {
			commit('SET_FAVORITE_SKILLS_FILTER', filter);
		},
		setfavoriteSkillsListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.favoriteSkillsPagination.$limit;
			commit('SET_FAVORITE_SKILLS_PAGINATION', { $skip });
			commit('SET_FAVORITE_SKILLS_FILTER', { $skip });
		},
		getAllFavoriteSkillsForTrust: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('api/v3/favourite-capabilities').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter
				  },
			});
			commit('SET_FAVORITE_SKILLS', results);
			commit('SET_FAVORITE_SKILLS_PAGINATION', { total: results.length });
			return results;
		},
		addFavoriteSkillsForTrust: async({ rootGetters, commit }, data) => {
			const url = '/api/v3/favourite-capabilities';
			const result = await feathersClient.service(url).create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				  },
			});
			return result;
		},
		deleteFavoriteSkillsForTrust: async({ rootGetters, commit }, capabilityId) => {
			const result = await feathersClient.service('api/v3/favourite-capabilities').remove(null, {
				query: {
					$role: rootGetters.currentUserRole,
				  	capabilityId: capabilityId,
				},
			  });
			return result;
		},

	},
};
